import React, { useEffect, useState } from "react";
import {
  ArrowRight,
  Bell,
  Code,
  Command,
  HelpCircle,
  LogOut,
  Map,
  Navigation2,
  Send,
  User,
  AlertCircle,
  Monitor
} from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { Departure, PlanePrivate, UserMultiple } from "@carbon/icons-react";
import tsawLogo from "../../assets/TSAW-logo-edit.png"
import Cookies from "js-cookie";

const Sidebar = () => {
  const links = [
    {
      name: "Monitor",
      link: "/",
      icon: <Monitor />,
    },
    {
      name: "Drones",
      link: "/dashboard/",
      icon: <Command />,
    },
    {
      name: "Missions",
      link: "/dashboard/mission",
      icon: <Map />,
    },
    {
      name: "Flights",
      link: "/layout/flights",
      icon: <Navigation2 />,
    },
    {
      name: "Manage Pilots",
      link: "/layout/pilots",
      icon: <UserMultiple size={24} />,
    },

    // {
    //   name: "Integration",
    //   link: "/layout/integration",
    //   icon: <Code />,
    // },
    // {
    //   name: "Help Center",
    //   link: "/layout/help",
    //   icon: <HelpCircle />,
    // },
    {
      name: "Report Issue",
      link: "/layout/issues",
      icon: <AlertCircle />,
    },
    {
      name: "DCIS Pilot",
      link: "https://pilot.tsaw.tech/",
      icon: <Departure size={24} />
    },
    {
      name: "Analyze Logs",
      link: "https://log.tsaw.tech/",
      icon: <PlanePrivate size={24} />
    },
  ];
  const { user, isPilot } = useAuthStore((state) => state);
  // console.log(user);
  const [isDrop, setDrop] = useState(false);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    Cookies.remove("access_token")
    navigate("/login");
  };

  // const [isHover, setHover] = useState(false);
  return (
    <div
      onMouseLeave={() => setDrop(false)}
      className="side-bar-wrap flex flex-col justify-between items-center p-4 border-r border-slate-300 h-screen shadow-right bg-white"
    >
      <div className="logo w-12 h-12">
        <Link to={"/"}>
          <img
            className="w-full h-full"
            style={{ objectFit: "contain" }}
            src={tsawLogo}
            alt="logo"
          />
        </Link>
      </div>
      <div className="links bg-blue-100 rounded-full">
        {links.filter(({ icon, name, link }) => {
          if (isPilot) {
            return name == "Monitor" || name == "Drones" || name == "Missions" || name == "Flights" || name == "Report Issue" || name == "Analyze Logs" || name == "DCIS Pilot"
          } else {
            return name
          }
        }).map(({ icon, name, link }, i) => (
          <>
            {
              name == "Analyze Logs" || name == "DCIS Pilot" ? (<Link to={link} key={i} target="_blank" className="group relative rounded-l-full flex my-4 p-4 hover:bg-slate-100 hover:text-tblu transition-all">
                <div className={`invisible group-hover:visible label absolute left-[100%] top-0 w-36 text-right p-4 bg-slate-100 z-[11] shadow-md rounded-r-full text-tblu`}>
                  {name}
                </div>
                {icon}
              </Link>) :
                (<Link
                  to={link}
                  key={i}
                  // onMouseEnter={() => setHover(true)}
                  // onMouseLeave={() => setHover(false)}
                  className="group relative rounded-l-full flex my-4 p-4 hover:bg-slate-100 hover:text-tblu transition-all"
                >
                  <div
                    className={`invisible group-hover:visible label absolute left-[100%] top-0 w-36 text-right p-4 bg-slate-100 z-[11] shadow-md rounded-r-full text-tblu`}
                  >
                    {name}
                  </div>
                  {icon}
                </Link>)
            }
          </>
        ))}
      </div>
      <div className="user relative">
        {isDrop && (
          <div className="absolute menu border z-[11] border-tblu rounded-xl shadow-xl bg-white bottom-0 left-[100%] p-2">
            <div className="user-profile w-fit flex justify-between items-start border rounded-xl p-2">
              <div>
                <div className="name text-xl font-bold whitespace-nowrap mr-6">
                  {user?.data?.fullName || user?.fullName}
                </div>
                <div className="email">{user?.data?.email || user?.email}</div>
              </div>
              <div className="role text-tblu uppercase bg-blue-100 px-4 rounded-full">
                {user?.data?.userType || user.userType}
              </div>
            </div>
            <Link to={"/layout/guidelines"}>
              <button
                className="text-xl flex justify-between items-center text-tblu w-full transition-all hover:underline hover:bg-blue-100 px-4 py-2 rounded-xl"
              >
                <span>Guidelines</span>
                <ArrowRight />
              </button>
            </Link>
            <Link to={"/layout/help"}>
              <button
                className="text-xl flex justify-between items-center text-tblu w-full transition-all hover:underline hover:bg-blue-100 px-4 py-2 rounded-xl"
              >
                <span>Help</span>
                <ArrowRight />
              </button>
            </Link>
            <Link to={"/layout/manual"}>
              <button
                className="text-xl flex justify-between items-center text-tblu w-full transition-all hover:underline hover:bg-blue-100 px-4 py-2 rounded-xl"
              >
                <span>UTM Manual</span>
                <ArrowRight />
              </button>
            </Link>

            <Link to={"/change-password"}>
              <button
                // onClick={handleLogout}
                className="text-xl flex justify-between items-center text-tblu w-full transition-all hover:underline hover:bg-blue-100 px-4 py-2 rounded-xl"
              >
                <span>Change Password</span>
                <ArrowRight />
              </button>
            </Link>
            <button
              name="logout-btn"
              onClick={handleLogout}
              className="text-xl flex justify-between items-center text-red-400 w-full transition-all hover:underline hover:bg-red-400 hover:text-white px-4 py-2 rounded-xl"
            >
              <span>Logout</span>
              <LogOut />
            </button>
          </div>
        )}
        {/* <div className="notifs cursor-pointer">
          <div className="notif-icon relative p-4 rounded-full border mb-4">
            <div className="absolute top-0 right-0">
              <span className="relative flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500"></span>
              </span>
            </div>
            <Bell />
          </div>
        </div> */}
        <div
          onClick={() => setDrop(!isDrop)}
          className="user-icon p-4 rounded-full border cursor-pointer"
        >
          <User />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
